export default "__VITE_ASSET__DIfQrHfc__"